import { Box, Typography } from "@mui/material";
import { useRouteError } from "react-router";

export default function ErrorBoundary() {
    const error = useRouteError();

    return (
        <Box sx={{
            padding: 2
        }}>
            <Typography variant="h6">Something went wrong.</Typography>
            <details style={{ whiteSpace: "pre-wrap" }}>
                {(error as any)?.stack}
            </details>
        </Box>
    );
}
